/**
 * Payment List API
 * ดึงรายการ Payment จาก backend
 */
import axios from '@/axios'

/**
 * GET /payment/list/formats
 * ดึงรายการพร้อม format สำหรับแต่ละ component
 * @returns {Promise<{bankOptions, navItems, filterItems, paymentMethods}>}
 */
export async function getPaymentListFormats () {
  const res = await axios.get('/payment/list/formats')
  return res.data
}

/**
 * GET /payment/list
 * ดึงรายการ payment แบบ raw
 */
export async function getPaymentList () {
  const res = await axios.get('/payment/list')
  return res.data.data || []
}
